import React from 'react'
import { Separator } from '@mc/design-system'
import { Trans, withI18nContext } from '@mc/i18n'
import { TrackingContainer } from '@mc/visibility'
import CertificateBadge from '../../assets/certificate-badge.svg'
import {
  CERTS_ADD_ON_SURFACE,
  trackCertsAddOnViewed,
} from '../../events/certsAddOnViewed'
import { useExperimentCriteria } from '../../hooks/useExperimentCriteria'
import { CERTS_QUIZ_PLANS_I18N_NAMESPACE, i18nInstance } from '../../i18n'

export const PlansPrimerCertsValue = withI18nContext(i18nInstance)(() => {
  const { isEligible } = useExperimentCriteria()

  if (!isEligible) return null

  return (
    <TrackingContainer
      className='mc-w-100'
      onFirstVisible={() => trackCertsAddOnViewed(CERTS_ADD_ON_SURFACE.PRIMER)}
    >
      <Separator className='mc-my-4' />
      <div className='d-flex align-items-center justify-content-start'>
        <CertificateBadge
          aria-hidden='true'
          className='mc-icon mc-icon--md mc-mr-3 flex-shrink-0'
        />
        <p style={{ maxWidth: '440px' }}>
          <Trans
            i18nKey='plansPrimer.certs'
            ns={CERTS_QUIZ_PLANS_I18N_NAMESPACE}
            components={{ bold: <span className='mc-text--bold' /> }}
          />
        </p>
      </div>
    </TrackingContainer>
  )
})
